import { Component } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { SnackBarService } from "app/services/snackbar.service";
import { CheckinService } from "../checkin/checkin.service";
import { ScheduleSummaryService } from "./schedule-summary.service";
import * as moment from "moment";
import { ScheduleService } from "../schedule/schedule.service";

export interface Historico {}

@Component({
    selector: "schedule-summary",
    templateUrl: "./schedule-summary.component.html",
    styleUrls: ["./schedule-summary.component.scss"],
})
export class ScheduleSummaryComponent {
    paciente: any;
    schedule: any;
    professionalList: any;
    professional: any;
    insuranceList: any;
    insurance: any;

    isLoading = true;
    checkIn: boolean;

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    constructor(
        private readonly scheduleSummaryService: ScheduleSummaryService,
        private readonly checkinService: CheckinService,
        private readonly scheduleService: ScheduleService,
        private progressBar: FuseProgressBarService,
        private snackBar: SnackBarService,
        private router: Router,
        public _matDialog: MatDialog
    ) {
        if (this.router.getCurrentNavigation().extras.state) {
            this.schedule = this.router.getCurrentNavigation().extras.state.schedule;
            this.getCurrentDate();
        } else {
            this.router.navigate(["/agenda"]);
        }
    }

    async ngOnInit() {
        this.paciente = JSON.parse(localStorage.getItem("paciente"));
    }

    ngAfterViewInit() {
        console.log(this.schedule)
        this.getInfo();
    }

    printSummary() {
        window.print();
    }

    async getInfo() {
        this.progressBar.show();

        this.professionalList = await this.scheduleSummaryService.getPerformerList();

        if (this.professionalList.length) {
            this.professional = this.professionalList.find(
                (professional) =>
                    professional.performerId == this.schedule.idProfissional
            );
            this.isLoading = false;
            this.progressBar.hide();
        }
        console.log(this.professional)
        this.insuranceList = await this.scheduleSummaryService.getInsuranceList();

        if (this.professionalList.length) {
            this.insurance = this.insuranceList.find(
                (insurance) => insurance.id == this.schedule.idConvenio
            );
            this.isLoading = false;
            this.progressBar.hide();
        }
    }

    async handleCheckIn() {
        {
            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                }
            );

            this.confirmDialogRef.componentInstance.confirmMessage =
                "Deseja confirmar presença?";
            this.confirmDialogRef.componentInstance.confirmTitle = "Check-In";

            this.confirmDialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.saveCheckin();
                }
                this.confirmDialogRef = null;
            });
        }
    }

    async saveCheckin() {
        moment.locale('pt-br');
        this.progressBar.show();
        
        try {
            
            console.log(this.schedule);
            await this.checkinService.checkin(this.schedule.idAgenda).then(res =>{
                let response = res.data;
                this.schedule.situacaoAgenda = response.patientStatus;
            });           
         

       
            this.snackBar.successMessage("Presença confirmada com sucesso!");
            this.checkIn = false;
            this.progressBar.hide();
        } catch (error) {
            this.snackBar.errorMessage("Ocorreu um erro, tente novamente");
            this.progressBar.hide();
        
        }
    }

    getCurrentDate() {
        var d = new Date(),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        const currentDate = [year, month, day].join("-");
        this.checkIn = currentDate == this.schedule.dataAgenda;
    }
}
